type LayoutMode = 'rectangle' | 'square';

interface GetOptionsGridClassesParams {
    optionCount: number;
    hasImage: boolean;
    layoutMode: LayoutMode;
}

export const getOptionsGridClasses = ({
  optionCount = 0,
  hasImage = false,
  layoutMode = 'rectangle'
}: GetOptionsGridClassesParams) => {
  // When image/file uploader is shown in rectangle mode, use single column
  if (hasImage && layoutMode !== 'square') {
    return `grid-cols-1 grid-rows-${optionCount}`;
  }

  if (optionCount === 2) return 'grid-cols-2 grid-rows-1';

  return 'grid-cols-2 grid-rows-2';
};
